// Service Worker registration and management

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
);

export function register() {
  if ('serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/sw.js`;

      if (isLocalhost) {
        checkValidServiceWorker(swUrl);
      } else {
        registerValidSW(swUrl);
      }
    });
  }
}

function registerValidSW(swUrl) {
  navigator.serviceWorker
    .register(swUrl)
    .then(registration => {
      console.log('✓ Service Worker registered successfully:', registration);
      
      // Check for updates every 60 seconds
      setInterval(() => {
        registration.update();
      }, 60000);
      
      registration.addEventListener('updatefound', () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.addEventListener('statechange', () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              console.log('New content available; waiting for SW activation message...');
              // Don't auto-reload here - let the SW_UPDATED message handle it
              // This prevents double reloads
            } else {
              console.log('Content cached for offline use.');
            }
          }
        });
      });
    })
    .catch(error => {
      console.error('Service Worker registration failed:', error);
    });
}

function checkValidServiceWorker(swUrl) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then(response => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl);
      }
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(registration => {
        registration.unregister();
      })
      .catch(error => {
        console.error(error.message);
      });
  }
}

// Listen for service worker messages
if ('serviceWorker' in navigator) {
  // Track if we've already reloaded to prevent loops
  let hasReloaded = false;
  
  navigator.serviceWorker.addEventListener('message', event => {
    if (event.data && event.data.type === 'SYNC_API_CALLS') {
      // Trigger API sync from the main thread
      const syncEvent = new CustomEvent('sw-api-sync');
      window.dispatchEvent(syncEvent);
    }
    
    if (event.data && event.data.type === 'SW_UPDATED') {
      // Service worker updated and activated
      console.log('Service Worker updated to version:', event.data.version);
      
      // Only reload once and mark in sessionStorage to prevent loops
      const lastReloadVersion = sessionStorage.getItem('sw_last_reload_version');
      if (!hasReloaded && lastReloadVersion !== event.data.version) {
        console.log('Reloading page for service worker update...');
        hasReloaded = true;
        sessionStorage.setItem('sw_last_reload_version', event.data.version);
        window.location.reload();
      } else {
        console.log('Skipping reload - already reloaded for this version');
      }
    }
  });
}